import { BreadcrumbItem, Breadcrumbs, Card, Chip, Image } from "@heroui/react";
import SectionTitle from "../components/common/SectionTitle";
import { FaFacebook, FaInstagram, FaLink, FaXTwitter } from "react-icons/fa6";

const blogData = [{
    id: '1',
    title: 'Oxford College Gampaha: A Beacon of Excellence in Education',
    category: 'Education',
    date: '17 Feb 2025',
    img: 'https://images.pexels.com/photos/2982449/pexels-photo-2982449.jpeg'
}, {
    id: '2',
    title: 'The Oxford College Gampaha Experience: A Day in the Life of a Student',
    category: 'Diversity',
    date: '18 Feb 2025',
    img: 'assets/images/events/preschool-activities/img5.webp'
}, {
    id: '3',
    title: 'Preparing for the Future: Career Guidance and Higher Education Support at Oxford College Gampaha ',
    category: 'Higher Education',
    date: '19 Feb 2025',
    img: 'https://images.pexels.com/photos/6334763/pexels-photo-6334763.jpeg'
}, {
    id: '4',
    title: 'Celebrating Diversity: The Inclusive Culture of Oxford College Gampaha',
    category: 'Diversity',
    date: '20 Feb 2025',
    img: 'https://images.pexels.com/photos/6333733/pexels-photo-6333733.jpeg'
}, {
    id: '5',
    title: 'Innovation in Education: How Oxford College Gampaha is Shaping the Future of Learning',
    category: 'Education',
    date: '21 Feb 2025',
    img: 'https://images.pexels.com/photos/1595391/pexels-photo-1595391.jpeg'
},]

const RecentBlogsCard = ({ img, title, date, id }) => {
    return (
        <Card isPressable
            onPress={() => window.location.href = `/blog-detailed?id=${id}`}
            shadow={'none'} className="border w-full flex flex-row items-center mt-5" radius="sm">
            <div className="h-28 w-28 bg-red-500 flex-shrink-0 items-center justify-center flex overflow-hidden">
                <Image
                    src={img}
                    alt='Blog Image'
                    width={150}
                    height={150}
                    className='rounded-md object-cover'
                />
            </div>
            <div className="flex-grow text-start px-2">
                <h4 className="leading-[20px] text-sm">
                    {title}
                </h4>
                <p className="text-tiny text-neutral-400 mt-2">{date}</p>
            </div>
        </Card>
    );
}

const BlogSingleView = () => {
    // Get the blog id from the URL
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get('id');

    // Find the matching blog entry
    const blog = blogData.find(blog => blog.id === id);

    // Extract the title from the matching blog entry
    const blogTitle = blog ? blog.title : 'Blog Title Not Found';

    const img = blog ? blog.img : 'Image Not Found';

    const date = blog ? blog.date : 'Date Not Found';

    const recentBlogs = blogData.filter(blog => blog.id !== id);

    return (
        <div className='px-4 container mx-auto'>
            <Breadcrumbs size={'sm'} variant='solid' className='mt-8'>
                <BreadcrumbItem href={"/"}>Home</BreadcrumbItem>
                <BreadcrumbItem href={'/blog'}>Blog</BreadcrumbItem>
                <BreadcrumbItem>Detailed</BreadcrumbItem>
            </Breadcrumbs>
            <div className='grid grid-cols-1 lg:grid-cols-6'>
                <div className='lg:col-span-4'>
                    {/* Set the title dynamically */}
                    <SectionTitle titleText={blogTitle} customClassNames={'mt-6'} />

                    {/* Rest of the code remains the same */}
                    <div className="flex items-center justify-between">
                        {/*    author details   */}
                        <div className='flex items-center gap-2 mt-4'>
                            <img
                                src={'https://wac-cdn.atlassian.com/dam/jcr:ba03a215-2f45-40f5-8540-b2015223c918/Max-R_Headshot%20(1).jpg?cdnVersion=2488'}
                                alt='author'
                                className='w-10 h-10 rounded-full' />
                            <div>
                                <h4 className='font-semibold text-neutral-800'>
                                    Oxford College - Gampaha
                                </h4>
                                <p className='text-tiny text-neutral-400'>
                                    {date}
                                </p>
                            </div>
                        </div>

                        {/*share blog*/}
                        <div className='flex items-center gap-2 mt-4'>
                            <div className='bg-blue-600 text-tiny w-6 h-6 flex items-center justify-center rounded-md'>
                                <FaFacebook className='text-white' />
                            </div>
                            <div className='bg-red-500 text-tiny w-6 h-6 flex items-center justify-center rounded-md'>
                                <FaInstagram className='text-white' />
                            </div>
                            <div className='bg-blue-500 text-tiny w-6 h-6 flex items-center justify-center rounded-md'>
                                <FaXTwitter className='text-white' />
                            </div>
                            <div className='bg-neutral-600 text-tiny w-6 h-6 flex items-center justify-center rounded-md'>
                                <FaLink className='text-white' />
                            </div>
                        </div>
                    </div>

                    {/*    blog image   */}
                    <Image
                        src={
                            img
                        }
                        alt='Blog Image'
                        width={2000}
                        height={400}
                        className='rounded-md object-cover mt-4'
                    />

                    {/*    blog content   */}
                    <div className='mt-4'>
                        {(id === '1') ?
                            <>
                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Nestled in the heart of Gampaha, Oxford College stands as a testament to academic excellence, holistic development, and a commitment to
                                    nurturing future leaders. With a rich history and a forward-thinking approach to education, Oxford College Gampaha has become a trusted name
                                    for parents and students alike. In this blog, we&apos;ll explore what makes Oxford College Gampaha a standout institution and why it continues to be a
                                    top choice for education in Sri Lanka.
                                </p>

                                <h3 className="text-2xl font-semibold mt-8">
                                    A Legacy of Excellence
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Oxford College Gampaha has built a reputation for delivering quality education that goes beyond textbooks. The institution is dedicated to
                                    fostering a love for learning, critical thinking, and creativity among its students. With a team of highly qualified and passionate educators, the
                                    college ensures that every student receives personalized attention and guidance to reach their full potential.
                                </p>

                                <h3 className="text-2xl font-semibold mt-8">
                                    Holistic Education: Beyond Academics
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    At Oxford College Gampaha, education is not confined to the classroom. The college places a strong emphasis on holistic development, offering
                                    a wide range of extracurricular activities, including sports, music, drama, and debate. These activities help students discover their talents, build
                                    confidence, and develop essential life skills such as teamwork, leadership, and time management.
                                    <br />
                                    <br />
                                    The college also organizes educational trips, community service projects, and cultural events, providing students with opportunities to broaden
                                    their horizons and give back to society. This well-rounded approach ensures that students graduate not only with academic knowledge but also
                                    with the skills and values needed to thrive in a rapidly changing world.
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    Holistic Education: Beyond Academics
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    At Oxford College Gampaha, education is not confined to the classroom. The college places a strong emphasis on holistic development, offering
                                    a wide range of extracurricular activities, including sports, music, drama, and debate. These activities help students discover their talents, build
                                    confidence, and develop essential life skills such as teamwork, leadership, and time management.
                                    <br />
                                    <br />
                                    The college also organizes educational trips, community service projects, and cultural events, providing students with opportunities to broaden
                                    their horizons and give back to society. This well-rounded approach ensures that students graduate not only with academic knowledge but also
                                    with the skills and values needed to thrive in a rapidly changing world.
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    State-of-the-Art Facilities
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Oxford College Gampaha is equipped with modern facilities designed to enhance the learning experience. From well-equipped science labs and
                                    computer rooms to a spacious library and sports grounds, the college provides an environment where students can explore, experiment, and excel.
                                    The campus is designed to inspire creativity and innovation, making it a perfect place for young minds to grow.
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    A Focus on Technology and Innovation
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    In today&apos;s digital age, Oxford College Gampaha recognizes the importance of integrating technology into education. The college offers cutting
                                    edge IT resources and encourages students to embrace technology as a tool for learning and problem-solving. By staying ahead of the curve,
                                    Oxford College ensures that its students are prepared for the challenges of the 21st century.
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    A Supportive and Inclusive Community
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    One of the hallmarks of Oxford College Gampaha is its warm and inclusive community. The college values diversity and strives to create an
                                    environment where every student feels welcomed and supported. With a strong emphasis on character development and moral values, the college
                                    instills in its students a sense of responsibility, respect, and empathy.
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    Achievements and Accolades
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Over the years, Oxford College Gampaha has produced outstanding results in both local and international examinations. The college takes pride
                                    in its students&apos; achievements, whether in academics, sports, or the arts. These accomplishments are a testament to the hard work and dedication of
                                    both the students and the faculty.
                                </p>

                                <h3 className="text-2xl font-semibold mt-8">
                                    Why Choose Oxford College Gampaha?
                                </h3>

                                <ul className='text-lg text-neutral-800 pt-4 text-justify list-inside list-disc'>
                                    <li>A proven track record of academic excellence</li>
                                    <li> A holistic approach to education</li>
                                    <li>Modern facilities and resources </li>
                                    <li>A focus on technology and innovation</li>
                                    <li>A supportive and inclusive community</li>
                                    <li>A wide range of extracurricular activities</li>
                                </ul>

                                <h3 className="text-2xl font-semibold mt-8">
                                    Conclusion
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Oxford College Gampaha is more than just a school; it&apos;s a place where dreams are nurtured, talents are honed, and futures are built. By
                                    combining academic rigor with a commitment to holistic development, the college prepares its students to face the world with confidence and
                                    compassion. If you&apos;re looking for an institution that values excellence, innovation, and character, Oxford College Gampaha is the perfect choice.

                                    <br /><br />
                                    Join the Oxford College Gampaha family and be a part of a legacy that shapes leaders for tomorrow!
                                </p>
                                <h3 className="text-2xl font-semibold mt-8">
                                    Call to Action
                                </h3>

                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                    Are you ready to embark on an educational journey like no other? Visit Oxford College Gampaha today to learn more about their programs,
                                    facilities, and admission process. Let&apos;s build a brighter future together!
                                    <br /><br />
                                    Follow Oxford College Gampaha on social media for updates, events, and success stories!
                                </p>
                            </>
                            : (id === '2') ?
                                <>
                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        Ever wondered what a typical day looks like at Oxford College Gampaha? From morning assemblies to
                                        extracurricular activities, the college offers a vibrant and enriching experience for its students. In this
                                        blog, we&apos;ll take you through a day in the life of an Oxford College student, highlighting the balance
                                        between academics, extracurriculars, and personal growth.
                                    </p>

                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        <span className="font-bold">
                                            Morning Routine: &nbsp;
                                        </span>
                                        Start the day with a motivating assembly, where students gather to reflect, plan, and
                                        set goals for the day.
                                    </p>
                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        <span className="font-bold">
                                            Academic Sessions: &nbsp;
                                        </span>
                                        Engaging lessons taught by experienced faculty, with a focus on interactive learning
                                        and critical thinking.
                                    </p>
                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        <span className="font-bold">
                                            Extracurricular Activities: &nbsp;
                                        </span>
                                        From sports practices to music rehearsals, students explore their passions and
                                        talents.
                                    </p>
                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        <span className="font-bold">
                                            After-School Programs: &nbsp;
                                        </span>
                                        Optional tutoring, clubs, and community service projects that extend learning
                                        beyond the classroom.
                                    </p>
                                    <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                        At Oxford College Gampaha, every day is an opportunity to learn, grow, and make lasting memories. It&apos;s
                                        not just about academics; it&apos;s about creating a well-rounded experience that prepares students for life.
                                    </p>
                                </>
                                : (id === '3') ?
                                    <>
                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            Choosing a career path is one of the most important decisions a student will make. At Oxford College
                                            Gampaha, we understand the importance of guiding our students toward their dreams. In this blog,
                                            we&apos;ll explore how the college&apos;s career guidance and higher education support programs help students
                                            make informed decisions about their futures.
                                        </p>

                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            <span className="font-bold">
                                                Career Counseling: &nbsp;
                                            </span>
                                            Personalized sessions with experienced counselors to help students identify their
                                            strengths and interests.
                                        </p>
                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            <span className="font-bold">
                                                Workshops and Seminars: &nbsp;
                                            </span>
                                            Regular events featuring industry professionals and alumni to inspire and
                                            inform students.
                                        </p>
                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            <span className="font-bold">
                                                Skill Development: &nbsp;
                                            </span>
                                            Programs focused on resume building, interview skills, and networking.
                                        </p>
                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            <span className="font-bold">
                                                Success Stories: &nbsp;
                                            </span>
                                            Testimonials from Oxford College alumni who have gone on to achieve great things in
                                            their chosen fields.
                                        </p>
                                        <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                            Oxford College Gampaha is committed to helping students turn their aspirations into reality. With the
                                            right guidance and support, the possibilities are endless.
                                        </p>
                                    </>
                                    : (id === '4') ?
                                        <>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                At Oxford College Gampaha, diversity is celebrated, and inclusivity is a core value. The college is home to
                                                students from various backgrounds, cultures, and traditions, creating a vibrant and dynamic community.
                                                In this blog, we&apos;ll explore how the college fosters an inclusive environment where every student feels
                                                valued and respected.
                                            </p>

                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                <span className="font-bold">
                                                    Cultural Events: &nbsp;
                                                </span>
                                                Annual celebrations that showcase the rich traditions of Sri Lanka and beyond.
                                            </p>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                <span className="font-bold">
                                                    Student Clubs: &nbsp;
                                                </span>
                                                Organizations that promote cultural exchange and understanding.
                                            </p>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                <span className="font-bold">
                                                    Anti-Bullying Initiatives: &nbsp;
                                                </span>
                                                Programs designed to create a safe and welcoming environment for all
                                                students.
                                            </p>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                <span className="font-bold">
                                                    Community Service: &nbsp;
                                                </span>
                                                Opportunities for students to give back and make a positive impact on society.
                                            </p>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                <span className="font-bold">
                                                    Testimonials: &nbsp;
                                                </span>
                                                Stories from students and parents about their experiences at Oxford College Gampaha.
                                            </p>
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                Oxford College Gampaha is more than just a school; it&apos;s a community where everyone belongs. By
                                                embracing diversity, the college prepares students to thrive in a globalized world.
                                            </p>
                                        </>
                                        : (id === '5') ?
                                            <>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    In a world that&apos;s constantly evolving, education must keep pace. Oxford College Gampaha is at the
                                                    forefront of innovation, integrating technology and modern teaching methods to create a dynamic
                                                    learning environment. In this blog, we&apos;ll explore how the college is shaping the future of education.
                                                </p>

                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    <span className="font-bold">
                                                        Smart Classrooms: &nbsp;
                                                    </span>
                                                    Equipped with the latest technology to enhance the learning experience.
                                                </p>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    <span className="font-bold">
                                                        STEM Programs: &nbsp;
                                                    </span>
                                                    Hands-on science, technology, engineering, and math activities that encourage
                                                    creativity and problem-solving.
                                                </p>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    <span className="font-bold">
                                                        E-Learning Platforms: &nbsp;
                                                    </span>
                                                    Online resources and tools that support remote and blended learning.
                                                </p>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    <span className="font-bold">
                                                        Teacher Training: &nbsp;
                                                    </span>
                                                    Continuous professional development for faculty to stay updated on the latest
                                                    educational trends.
                                                </p>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    <span className="font-bold">
                                                        Student Projects: &nbsp;
                                                    </span>
                                                    Innovative assignments and competitions that challenge students to think outside the
                                                    box.
                                                </p>
                                                <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                    Oxford College Gampaha is not just preparing students for the future; it&apos;s helping them shape it. By
                                                    embracing innovation, the college ensures that its students are ready to tackle the challenges and
                                                    opportunities of tomorrow.
                                                </p>
                                            </>
                                            :
                                            <p className='text-lg text-neutral-800 pt-4 text-justify'>
                                                Blog Content Not Found
                                            </p>
                        }
                    </div>
                </div>
                <div className='lg:col-span-2 hidden lg:block px-4'>

                    {/* <Input
                        placeholder={'Search'}
                        startContent={
                            <div className='text-neutral-500'>
                                <FaSearch />
                            </div>
                        }
                        className={'mt-8'}
                    /> */}

                    <h3 className='text-4xl font-bebas mt-8'>Recent Blogs</h3>

                    {recentBlogs.map((blog, index) => (
                        <RecentBlogsCard
                            key={index}
                            img={blog.img}
                            title={blog.title}
                            date={blog.date}
                            id={blog.id}
                        />
                    ))}

                    <h3 className='text-4xl font-bebas mt-8'>Categories</h3>

                    <div className='mt-4 flex flex-wrap gap-1'>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Technology</Chip>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Education</Chip>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Technology</Chip>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Business</Chip>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Marketing</Chip>
                        <Chip size={"sm"} className='text-tiny text-primary-blue'>Sales</Chip>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default BlogSingleView;